import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Verificar se o elemento root existe antes de criar o root
const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error('Elemento #root não encontrado no DOM');
  throw new Error('Elemento #root não encontrado no DOM');
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
